import { twMerge } from 'tailwind-merge';
import { formatUserName } from '@witmetrics/utils/strings';
import { formatDateWithTime } from '@witmetrics/utils/time';
import {
  useActivePractice,
  useDateFormatPreference,
  usePracticeUsers,
} from '@witmetrics/data-store';
import { type PendingTask, useNewCase } from '@/providers/NewCaseProvider';
import Card from '@/components/Card';
import IconButton from '@/components/IconButton';
import Title from '@/components/Title';
import { CloseIcon } from '@/icons';
import { classes, styles } from './utils';

export type TaskItemProps = {
  className?: string;
  task: PendingTask;
  onEdit: (uuid: string) => void;
};

export default function TaskItem({
  className,
  task: { uuid, dueAt, assignedTo, description },
  onEdit,
}: TaskItemProps) {
  const activePractice = useActivePractice();
  const dateFormat = useDateFormatPreference();
  const practiceUsers = usePracticeUsers(activePractice?.id);
  const { onRemovePendingTask } = useNewCase();

  const assignee = practiceUsers?.find((pu) => pu.user.id === assignedTo)?.user;

  return (
    <Card sx={styles.card} className={twMerge(classes.card, className)}>
      <button
        className={classes.content}
        type="button"
        onClick={() => onEdit(uuid)}>
        <div className={classes.details}>
          <Title className={classes.title} size="xs">
            {description}
          </Title>
          <div className={classes.subtitle}>
            {formatDateWithTime(dueAt, dateFormat)}
            {assignee && ` · ${formatUserName(assignee)}`}
          </div>
        </div>
      </button>
      <IconButton onClick={() => onRemovePendingTask(uuid)}>
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    </Card>
  );
}
